module.exports = __webpack_public_path__ + "static/HoverSplash-73a3ec00108af8cbc365ec76f6fb2d8e.png";